import type { ReactNode } from "react";

export function PipelineCell({ width, divider = true, align = "flex-start", grow = false, children }: { width: number; divider?: boolean; align?: "flex-start" | "center"; grow?: boolean; children: ReactNode }) {
  return (
    <div style={{
      width: grow ? undefined : width, flex: grow ? `1 1 ${width}px` : undefined, minWidth: grow ? 0 : undefined,
      boxSizing: "border-box", flexShrink: grow ? 1 : 0, overflow: grow ? "hidden" : undefined,
      padding: "0 var(--space-4)", borderLeft: divider ? "1px solid var(--color-surface-100)" : "none",
      display: "flex", flexDirection: "column", justifyContent: "center", alignItems: align, gap: 4,
    }}>
      {children}
    </div>
  );
}

export function ColHeader({ children }: { children: ReactNode }) {
  return <div style={{ fontSize: 11, fontWeight: 600, color: "var(--color-surface-700)", textTransform: "uppercase", letterSpacing: "0.5px", whiteSpace: "nowrap" }}>{children}</div>;
}
